<script>
  import PrismicDOM from 'prismic-dom'
  import castArray from 'lodash/castArray'
  import { findNodeInEventPath } from '~/utils/dom'
  import { urlToUri } from '~/utils/routing'
  import { hasMethod } from '~/utils/framework'

  export default {
    name: 'PrismicRichText',
    render (h) {
      if (!this.field) return null

      return <section domPropsInnerHTML={this.asHTML()} />
    },
    props: {
      field: {
        default: () => {},
        type: [Array, Object],
      },
      htmlSerializer: {
        default: null,
        type: Function,
      },
      linkResolver: {
        default: null,
        type: Function,
      },
    },
    data () {
      return {
        localLinks: [],
      }
    },
    methods: {
      asHTML () {
        return PrismicDOM.RichText.asHtml(
          castArray(this.field),
          this.linkResolver || this.$prismic.linkResolver,
          this.htmlSerializer || this.$prismic.htmlSerializer,
        )
      },
      hijackLocalLinks () {
        this.localLinks = this.findLocalLinks()

        this.localLinks.forEach(link => {
          link.addEventListener('click', this.onLocalLinkClick)
        })
      },
      findLocalLinks () {
        if (
          typeof window === 'undefined'
        ) return

        const links = this.$el.querySelectorAll('a').values()
        const localLinks = []

        let item = links.next()
        while (!item.done) {
          const link = item.value

          if (link.hostname === window.location.hostname) {
            localLinks.push(link)
          }

          item = links.next()
        }

        return localLinks
      },
      onLocalLinkClick (e) {
        if (typeof window === 'undefined') return

        if (hasMethod(e, 'preventDefault')) {
          e.preventDefault()
        }

        if (hasMethod(e, 'propagationPath')) {
          const linkNode = findNodeInEventPath('A', e)

          if (linkNode) {
            const uri = urlToUri(this.$get(linkNode, 'href'))

            if (typeof uri === 'string' && uri.length) {
              this.$router.push(uri)
            }
          }
        }
      },
      releaseLocalLinks () {
        this.localLinks.forEach(link => link.removeEventListener('click', this.onLocalLinkClick))
      },
    },
    beforeDestroy () {
      this.releaseLocalLinks()
    },
    mounted () {
      this.hijackLocalLinks()
    },
  }
</script>
